module.exports = __webpack_public_path__ + "img/wx.26d7d8b8.png";